export const getBankMasterList = state => {
    return state.list
}

export const getBankMasterDataProps = state => {
    return state.props
}


// WEBPACK FOOTER //
// ./src/store/modules/bankMaster/getters.js